import DetailsData from 'txp-data/lib/schema/viewSchema/DetailsData';

export default function getDetailsEditableField(detailsData: DetailsData): string {
    if (detailsData && detailsData.fourthLine) {
        return detailsData.fourthLine.text;
    }
    return '';
}
